import React from 'react'
import _cx from 'classnames/bind'
import * as graph from '@adc/sdk'
import type { ContentMarketingAttribute } from '@adc/sdk/types'
// @ts-ignore no types
import { connect } from 'react-redux'
// @ts-ignore no types
import { Grid, Text, hooks } from '@adc/ui-adc'
import { useListingContext } from 'common/context/listing'
import SectionPanel from '../../components/sectionPanel'
// @ts-ignore no types
import cls from './index.scss'

const cx = _cx.bind(cls)

const Disclaimer = () => {
  const { listing } = useListingContext()
  const isMobile = hooks.useIsMobileHook()
  const disclaimer: ContentMarketingAttribute | undefined =
    listing.marketing_attributes?.find(
      item =>
        item?.attribute_type === graph.enums.MarketingAttributeType.Disclaimer
    ) as ContentMarketingAttribute

  return (
    <SectionPanel elmId='disclaimer_section'>
      <Grid>
        {disclaimer && disclaimer.message && (
          <Grid.Row>
            <Grid.Column computer={16} tablet={16} mobile={16}>
              <Text
                color='gray'
                size='tiny'
                className={cx(isMobile ? 'mobile-disclaimer' : '')}
                data-elm-id='disclaimer'
              >
                {disclaimer.message || disclaimer.default_display_value || ''}
              </Text>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </SectionPanel>
  )
}

export default Disclaimer
